import React from 'react';
import { useTranslation } from 'react-i18next';

import FormDrawer from '~/components/FormDrawer';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import buildNamePath from '~/utils/buildNamePath';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { Shareholders } from '~/types/Shareholders';

import BusinessForm, { formName } from './BusinessForm';
import { shareholdersKey } from '.';

interface Props extends Partial<FormItemInjectedProps<Shareholders>> {
  uid: string;
  onClose: () => void;
}

const BusinessEdit: React.FC<Props> = (props) => {
  const { value, onChange } = props as FormItemInjectedProps<Shareholders>;
  const { uid, onClose } = props;
  const { t } = useTranslation('fillApplication');

  const shareholdersFormState = { shareholders: value };
  const currentIndex = value?.businesses?.findIndex((item: any) => item?.data?.uid === uid) ?? 0;

  const onFinish = (newValues: ApplicationPayload | any) => {
    const updatedBusiness = newValues?.shareholders?.businesses[currentIndex];
    const businesses: any = value?.businesses;
    const updatedData = { ...value, businesses: businesses?.toSpliced(currentIndex, 1, updatedBusiness) };
    onChange(updatedData);
    onClose();
  };

  return (
    <FormDrawer
      id="businessEditDrawer"
      open={!!uid}
      onClose={onClose}
      title={t('Edit Legal Entity shareholder')}
      formName={formName}
    >
      <BusinessForm
        onFinish={onFinish}
        n={buildNamePath([shareholdersKey, 'businesses', currentIndex])}
        initialValues={shareholdersFormState}
        edit
      />
    </FormDrawer>
  );
};

export default BusinessEdit;
